export const SESION_ACTUAL = 'SESION_ACTUAL';

export const URL_SESION_FINALIZADA = ['/sesion-expirada'];
export const HASH = '#';
export const EMPTY = '';

// tslint:disable-next-line:quotemark
export const CARACTERES_NO_PERMITIDOS_LOGIN = "{|}|\\^|\\#|`|~|\\[|\\]|<|>|\\/|\\||'"; // {}^#`~[]<>/|

// tslint:disable-next-line:quotemark
export const CARACTERES_NO_PERMITIDOS_GENERICO = "{|}|\\^|\\#|`|~|\\[|\\]|<|>|\\/|\\||'"; // {}^#`~[]<>/|



// WEBPACK FOOTER //
// ./src/app/@compartidos/utils/consts.ts